const BASE_CURRENCY = 'USD';
const API_URL = 'https://api.forexapi.eu/v2/live';

const API_KEY = '1C819tnzprFy79YZhyTFVJ';

export const CURRENCY = {
  euro: 'EUR',
  pound: 'GBP',
  lira: 'TRY'
};

export const convertCurrency = async ({ unit = '' }) => {
  const baseURL = `${API_URL}?base=${BASE_CURRENCY}&counter=${unit}&apikey=${API_KEY}`;
  try {
    const response = await fetch(baseURL);

    if (response.status !== 200) throw new Error('');

    const data = await response.json();
    return data?.quotes[unit]?.bid;
  } catch (error) {
    return null;
  }
};
